import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { SharerService } from 'src/app/services/sharer.service';
import { environment } from 'src/environments/environment';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { RecipientService } from 'src/app/services/recipient.service';
declare var $: any;
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-add-recipient-modal',
  templateUrl: './add-recipient-modal.component.html',
  styleUrls: ['./add-recipient-modal.component.css']
})
export class AddRecipientModalComponent implements OnInit {

  @Input('ismodal') ismodal: any;
  @ViewChild('attachments') attachment: any;
  fileList: File[] = [];
  DocumentArray: any[] = [];
  combineArray: any[] = [];
  current_date_of_doc:any;
  listOfFiles: any[] = [];
  fileNameArray: any[] = [];
  public environmentSettings: any;
  PageTitle: any;
  addUPSIRecipient: FormGroup;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  documentType: any;
  RecipientType: any;
  disabledOnclick: boolean;
  recipientID: any;
  other_recipient_fields: any;
  isEdit: any;
  otherDocumentName: any;
  checkUniqueEmail: any;
  checkOtherDocumentNoVal: boolean;
  checkOtherDocumentNoValD: boolean;
  panNumberReq: boolean;
  otherNumberReq: boolean;
  RecipientName: any;
  fileSizeError: any;
  filesToUpload: any;
  DocumentFileDoc: any;
  FileNameO: any;
  isFileDeleted: any;
  fileExtension: boolean = true;
  public token: any = localStorage.getItem('token')

  downloadURLForUPSI: any = environment.pssServerUrl + "upsi/recipientDoc/";
  public ipLocalPc: any;
  constructor(private sharerService: SharerService, private loaderService:LoaderService, private customValidation: CustomValidation,
     private recipientService: RecipientService, private router: Router, private alert: AlertComponent,
     private location: Location, private activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal, public commonFunction: CommonFunction) {

  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.loaderService.disable();
    this.isEdit = false;
    this.environmentSettings = environment;
    this.PageTitle = 'UPSI Recipient',

      // this.sharerService.getClientIp().subscribe((response) => {
      //   // console.log('responseresponseresponse', JSON.parse(response['_body']))
      //   var ip = (response['ip']);
      //   this.ipLocalPc = ip
      // });


    this.addUPSIRecipient = new FormGroup({
      Name: new FormControl('', [
        Validators.required,
        this.customValidation.noWhitespaceValidator,
        Validators.pattern('[ a-zA-Z0-9!@#$^*%_?<>|=&()\\-`.+,:/\"]*'),
        Validators.maxLength(50),
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]),
      EmpCode: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'), Validators.maxLength(25)]),
      Designation: new FormControl('', [Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'), Validators.maxLength(50)]),
      Department: new FormControl('', [Validators.required, this.customValidation.noWhitespaceValidator, Validators.pattern('^[ a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'), Validators.maxLength(50)]),
      Unique_Identifier_Type: new FormControl('', [Validators.required]),
      Document_No: new FormControl('', []),
      email_id: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}')]),
      ContactNumber: new FormControl('', [Validators.required]),
      tele_Number: new FormControl('', []),
      Address_1: new FormControl('', [Validators.required]),
      Address_2: new FormControl('', []),
      Address_3: new FormControl('', []),
      city: new FormControl('', []),
      pin: new FormControl('', []),
      type_of_recipient: new FormControl('', [Validators.required]),
      other_recipient: new FormControl('', []),
      other_document_name: new FormControl('', [Validators.maxLength(50)]),
    });


    this.activatedRoute.params.subscribe(params => {
      if (params['recipientId']) {
        this.recipientID = params['recipientId'];
        this.recipientService.editRecipient(params['recipientId']).subscribe((recipientDATA:any) => {
          this.isEdit = true;
          this.RecipientName = recipientDATA.data[0].Name;
          this.addUPSIRecipient.controls.Name.setValue(recipientDATA.data[0].Name);
          this.addUPSIRecipient.controls.EmpCode.setValue(recipientDATA.data[0].EmpCode);
          this.addUPSIRecipient.controls.Designation.setValue(recipientDATA.data[0].Designation);
          this.addUPSIRecipient.controls.Department.setValue(recipientDATA.data[0].Department);
          this.addUPSIRecipient.controls.Unique_Identifier_Type.setValue(recipientDATA.data[0].Unique_Identifier_Type);
          this.addUPSIRecipient.controls.Document_No.setValue(recipientDATA.data[0].Document_No);
          this.addUPSIRecipient.controls.email_id.setValue(recipientDATA.data[0].email_id);
          this.addUPSIRecipient.controls.ContactNumber.setValue(recipientDATA.data[0].ContactNumber);
          this.addUPSIRecipient.controls.tele_Number.setValue(recipientDATA.data[0].tele_Number);
          this.addUPSIRecipient.controls.Address_1.setValue(recipientDATA.data[0].Address_1);
          this.addUPSIRecipient.controls.Address_2.setValue(recipientDATA.data[0].Address_2);
          this.addUPSIRecipient.controls.Address_3.setValue(recipientDATA.data[0].Address_3);
          this.addUPSIRecipient.controls.city.setValue(recipientDATA.data[0].city);
          this.addUPSIRecipient.controls.pin.setValue(recipientDATA.data[0].pin);
          this.addUPSIRecipient.controls.type_of_recipient.setValue(recipientDATA.data[0].type_of_recipient);
          this.addUPSIRecipient.controls.other_recipient.setValue(recipientDATA.data[0].other_recipient);
          this.addUPSIRecipient.controls.other_document_name.setValue(recipientDATA.data[0].other_document_name);
          this.documentType = recipientDATA.data[0].Unique_Identifier_Type;
          this.current_date_of_doc=recipientDATA.data[0].CreatedDate;
          this.DocumentFileDoc = recipientDATA.data[0].DocumentFile;
          this.DocumentArray = this.DocumentFileDoc.split(',');
          this.DocumentArray = this.DocumentArray.filter(function (e) {return e != "";});
          
          try{
            this.fileNameArray = recipientDATA.data[0].DocumentFile.split(',')
            this.fileNameArray = this.fileNameArray.filter(function (e) {return e != "";});
            console.log(this.fileNameArray);
          }catch{
            this.fileNameArray =  (recipientDATA.data[0].DocumentFile)?recipientDATA.data[0].DocumentFile.slice(recipientDATA.data[0].DocumentFile.indexOf("-")+1):""
          }
          
          
          this.documentType = recipientDATA.data[0].Unique_Identifier_Type;
          this.RecipientType = recipientDATA.data[0].type_of_recipient;
          this.DocumentFileDoc = recipientDATA.data[0].DocumentFile
          this.FileNameO = (recipientDATA.data[0].DocumentFile) ? recipientDATA.data[0].DocumentFile.slice(recipientDATA.data[0].DocumentFile.indexOf("-") + 1) : ""
          console.log('recipientDATA.data[0].DocumentFile ', recipientDATA.data[0].DocumentFile)


        });

      }
    });


  }

  initiateUploadDocument($event) {
    // console.log(data);
    
    // $("#documentUploadLable").html("Upload Notice Doc.");
    $("#UpsiUploadTitle").html("Attachment For UPSI");
    $("#upsiReciepentUploadDialog").modal('toggle');
  }
  onFileChanged(event: any) {

    if (this.fileList.length + event.target.files.length <= 10) {
      for (var i = 0; i <= event.target.files.length - 1; i++) {
        this.filesToUpload = event.target.files[i];
        let fileObj = {
          target: {
            files: [this.filesToUpload]
          }
        }
        if(this.commonFunction.checkFileExtension(fileObj)){

          var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj,fileObj)
          if(filenameValidation == "Valid"){
            this.fileList.push(this.filesToUpload);
            this.listOfFiles.push(this.filesToUpload.name);
          } else {
            this.alert.error(filenameValidation);
          }
        } else {
          this.alert.error("Invalid file extension")
        }
      }
    } else {
      this.alert.error("Number of files cannot be more than 10");
    }

    this.attachment.nativeElement.value = '';
    
  } 
  removeSelectedFile(index) {
    // Delete the item from fileNames list
    this.listOfFiles.splice(index, 1);
    // delete file from FileList
    this.fileList.splice(index, 1);
  }

  addAndUpdateRecipient() {

    this.disabledOnclick = true;
    var recipientID = this.recipientID;
    var date = new Date();
    var timestamp = date.getTime();

    var newRecipient = {
      Name: (this.addUPSIRecipient.controls.Name.value) ? this.addUPSIRecipient.controls.Name.value.trim() : "",
      EmpCode: (this.addUPSIRecipient.controls.EmpCode.value) ? this.addUPSIRecipient.controls.EmpCode.value.trim() : "",
      Designation: (this.addUPSIRecipient.controls.Designation.value) ? this.addUPSIRecipient.controls.Designation.value.trim() : "",
      Department: (this.addUPSIRecipient.controls.Department.value) ? this.addUPSIRecipient.controls.Department.value.trim() : "",
      Unique_Identifier_Type: (this.addUPSIRecipient.controls.Unique_Identifier_Type.value) ? this.addUPSIRecipient.controls.Unique_Identifier_Type.value.trim() : "",
      Document_No: (this.addUPSIRecipient.controls.Document_No.value) ? this.addUPSIRecipient.controls.Document_No.value.trim() : "",
      email_id: (this.addUPSIRecipient.controls.email_id.value) ? this.addUPSIRecipient.controls.email_id.value.trim().toLowerCase() : "",
      ContactNumber: (this.addUPSIRecipient.controls.ContactNumber.value) ? this.addUPSIRecipient.controls.ContactNumber.value : "",
      tele_Number: (this.addUPSIRecipient.controls.tele_Number.value) ? this.addUPSIRecipient.controls.tele_Number.value : "",
      Address_1: (this.addUPSIRecipient.controls.Address_1.value) ? this.addUPSIRecipient.controls.Address_1.value : "",
      Address_2: (this.addUPSIRecipient.controls.Address_2.value) ? this.addUPSIRecipient.controls.Address_2.value : "",
      Address_3: (this.addUPSIRecipient.controls.Address_3.value) ? this.addUPSIRecipient.controls.Address_3.value : "",
      city: (this.addUPSIRecipient.controls.city.value) ? this.addUPSIRecipient.controls.city.value : "",
      pin: (this.addUPSIRecipient.controls.pin.value) ? this.addUPSIRecipient.controls.pin.value : "",
      type_of_recipient: (this.addUPSIRecipient.controls.type_of_recipient.value) ? this.addUPSIRecipient.controls.type_of_recipient.value : "",
      other_recipient: (this.addUPSIRecipient.controls.other_recipient.value) ? this.addUPSIRecipient.controls.other_recipient.value : "",
      other_document_name: (this.addUPSIRecipient.controls.other_document_name.value) ? this.addUPSIRecipient.controls.other_document_name.value : "",
      DocumentFile: [] as any,
      ip_address: this.ipLocalPc
    }

    this.listOfFiles = this.listOfFiles.map(f =>{return `${timestamp}-${f}`});

    this.combineArray = this.listOfFiles.concat(this.fileNameArray);
    var removeNullElementFromArray = this.combineArray.filter(function (e) {return e != null;});
    newRecipient.DocumentFile.push(removeNullElementFromArray);
    newRecipient.DocumentFile = newRecipient.DocumentFile.join(',')
    console.log(this.combineArray);
    // if (!this.filesToUpload) {
    //   delete newRecipient.DocumentFile;
    // }

    // if (this.isFileDeleted && this.filesToUpload == undefined) {
    //   newRecipient.DocumentFile = null
    // }

    var recipientData = { 'recipientData': newRecipient, 'recipientID': recipientID }
    new Promise(resolve => this.recipientService.addrecipient(recipientData).subscribe((response) => {
      if (response.status == 1) {
        this.disabledOnclick = true;
        if (this.ismodal) {
          this.activeModal.dismiss('dismiss')
        }
        if(response.err_fields){
          this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')
        } else {
          this.alert.error(response.message)
        }
      } else {
        var recipientIdDoc;
        if (response.data._id) {
          recipientIdDoc = response.data._id;
        } else {
          recipientIdDoc = recipientID
        }

        if (this.filesToUpload) {
          // this.makeFileRequest(environment.pssUrl + "upsi/documentsFileRecipent/" +recipientIdDoc, timestamp, [this.filesToUpload], 'UPSI')
          this.makeFileRequest(environment.pssServerUrl + "upsi/documentsFileRecipent/" + recipientIdDoc, timestamp, this.fileList, 'UPSI').then((result) => {
            if (this.ismodal) {
              this.activeModal.close(response)
            } else {
              this.alert.successWithOk(response.message, 'userMaster/upsirecipient');
            }

          }, (error) => {
            this.alert.errorWithOk(error, 'userMaster/upsirecipient');
          });
        } else {
          if (this.ismodal) {
            this.activeModal.close(response)
          } else {
            this.alert.successWithOk(response.message, 'userMaster/upsirecipient');
          }
        }

      }

    }))
  }

  makeFileRequest(url: string, params: any, files: Array<File>, title: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], params + "-" + files[i].name.replace(',', ''));
      }
      console.log(formData);
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 10) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }
  onlyNumberPIN(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 6) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  otherRecipient(ev) {


    if ((ev.target.value).length < 1) {
      this.other_recipient_fields = true;
    } else {
      this.other_recipient_fields = false;
    }
  }

  onChangeUIType() {
    if (this.addUPSIRecipient.controls.Unique_Identifier_Type.value != '') {
      this.documentType = this.addUPSIRecipient.controls.Unique_Identifier_Type.value;
    }

    this.addUPSIRecipient.controls.other_document_name.setValue(null);
    this.addUPSIRecipient.controls.Document_No.setValue(null);

    if (this.documentType == 'Other') {
      this.otherDocumentName = true;
      this.otherNumberReq = true;
      this.panNumberReq = false;
      this.checkOtherDocumentNoValD = false;
    } else {
      this.otherDocumentName = false;
      this.panNumberReq = true;
      this.otherNumberReq = false;
      this.checkOtherDocumentNoVal = false;

    }
  }

  onChangeReType() {
    if (this.addUPSIRecipient.controls.type_of_recipient.value != '') {
      this.RecipientType = this.addUPSIRecipient.controls.type_of_recipient.value;
    }

    this.addUPSIRecipient.controls.other_recipient.setValue(null);

    if (this.RecipientType == 'Other') {
      this.other_recipient_fields = true;
    } else {
      this.other_recipient_fields = false;
    }


  }
  downloadFile(filename) {
  
    window.location.href = this.downloadURLForUPSI + filename + "/" + this.token;
  }

  deleteFile(index) {
    console.log(index)
    this.DocumentArray.splice(index,1);
    this.fileNameArray.splice(index,1);
    //this.DocumentFileDoc = false;
    this.isFileDeleted = true;
    // delete newRecipient.DocumentFile;
    // newRecipient.DocumentFile = null;
    this.activatedRoute.params.subscribe(params => {
      if (params['recipientId']) {
        this.recipientID = params['recipientId'];
        new Promise(resolve => this.recipientService.removeFileName(this.recipientID).subscribe((removeResponse) => {
          if (removeResponse.status == 1) {
            this.disabledOnclick = true;
            if (this.ismodal) {
              this.activeModal.dismiss('dismiss')
            }
            // this.alert.error(JSON.stringify(removeResponse.err_fields) + ' fields are required or invalid.')

          } else {
            //this.alert.successWithOk('File deleted successfully.', '/upsirecipient');
            // this.alert.successWithOk(response.message, '/upsirecipient');
          }
        }));
      }
    });
  }

  fileChanged($event) {
    // console.log('file changed', $event.target.files[0])
    //   this.filesToUpload = $event.target.files[0];
    //   console.log("this.filesToUpload", this.filesToUpload)

    var checkfile = this.commonFunction.checkFileExtension($event);
    if (checkfile) {
      this.filesToUpload = $event.target.files[0];
      this.fileExtension = true;
    } else {
      this.fileExtension = false;
    }
  }
  clear() {
    this.disabledOnclick = false;
    this.addUPSIRecipient.reset();
    this.ngOnInit();
  }

  back() {
    this.disabledOnclick = false;
    this.addUPSIRecipient.reset();
    this.ngOnInit();
    this.location.back();
  }

  otherDocumentNameFun(ev) {


    if ((ev.target.value).length < 1) {
      this.otherDocumentName = true;
    } else {
      this.otherDocumentName = false;
    }
  }
  otherDocumentValidation(ev) {
    var oDno = ev.target.value;
    if (oDno.trim().length) {
      if (!(/'/.test(oDno))) {
        this.checkOtherDocumentNoVal = false;
        this.otherNumberReq = false;
      } else {
        this.checkOtherDocumentNoVal = true;
      }

    } else {
      this.checkOtherDocumentNoVal = true;
    }
  }


  DocumentValidation(ev) {
    var oDno = ev.target.value;
    if (oDno.trim().length) {
      if (/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(oDno)) {
        this.checkOtherDocumentNoValD = false;
        this.panNumberReq = false;
      } else {
        this.checkOtherDocumentNoValD = true;
      }

    } else {
      this.checkOtherDocumentNoValD = true;
    }
  }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }
    var decrEmailId=this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      // EmailId: user.EmailId,
      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }



  checkuniqueEmail(ev) {
    if ((ev.target.value).length) {
      var email_id = ev.target.value;

      this.recipientService.CheckUniqeEmailWithInCmp(email_id).subscribe((sharerDATA:any) => {

        if (sharerDATA.status == 0) {
          if (this.recipientID == sharerDATA.data[0]._id) {
            this.checkUniqueEmail = false;
          } else {
            this.checkUniqueEmail = true;
          }

        } else {
          this.checkUniqueEmail = false;
        }
      });
    }
  }

}
